/** Вид эскиза секции. */
export type SketchKind =
  'hero' | 'grid' | 'cards' | 'logos' | 'stats' | 'text' | 'image' | 'list' | 'form';

interface FieldLike {
  key: string;
  type: string;
  options?: Record<string, unknown> | null | undefined;
  hidden?: boolean;
  parent_id?: string | undefined;
}

const BUILTIN: Record<string, SketchKind> = {
  heading: 'text',
  text: 'text',
  image: 'image',
  gallery: 'logos',
  quote: 'text',
  buttons: 'form',
  embed: 'image',
  video: 'image',
  table: 'list',
  divider: 'text',
  ref: 'image',
};

/**
 * Эскиз по устройству секции: картинки у секции нет, но её поля говорят,
 * на что она похожа. Подборка записей — карточки, цифры — столбики,
 * видео или картинка с заголовком — первый экран. Догадка, а не правда:
 * своя картинка у секции появится вместе с вариантами (шаг 6.7).
 */
export function sketchOf(slug: string, fields: readonly FieldLike[]): SketchKind {
  const builtin = BUILTIN[slug];

  if (builtin !== undefined) {
    return builtin;
  }

  const top = fields.filter((field) => field.hidden !== true && field.parent_id === undefined);
  const has = (type: string, multiple?: boolean) =>
    top.some(
      (field) =>
        field.type === type &&
        (multiple === undefined || (field.options?.['multiple'] === true) === multiple),
    );

  if (has('reference', true)) {
    return /client|logo|award|partner|brand/i.test(slug) ? 'logos' : 'cards';
  }

  if (top.some((field) => field.type === 'group' && /stat|number|digit|fact/i.test(field.key))) {
    return 'stats';
  }

  if (has('group')) {
    return 'list';
  }

  if (has('file') || (has('image', false) && has('string'))) {
    return 'hero';
  }

  if (has('image', true)) {
    return 'logos';
  }

  if (has('image')) {
    return 'image';
  }

  return 'text';
}
